import React, { Component } from 'react';

class DateExceptionPromptModal extends Component {
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    const { onSetDateExceptions, onCancel } = this.props;
    if (e.key === 'Escape') {
      onCancel();
    } else if (e.key === 'Enter') {
      onSetDateExceptions();
    }
  };

  render() {
    const { onSetDateExceptions, onCancel } = this.props;

    return (
      <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="date-exception-title">
        <div className="modal-container">
          <div className="modal-body">
            <h4 id="date-exception-title">Date Exceptions Required</h4>
            <div style={{ paddingTop: '15px' }}>
              This assessment has already ended. To continue, please set date exceptions for the selected student."
            </div>
            <div className="modal-footer" style={{ border: 'none', paddingBottom: '30px' }}>
              <button
                className="actionBtn"
                style={{ position: 'relative', right: '53%' }}
                onClick={onSetDateExceptions}
                autoFocus
              >
                Set Date Exceptions
              </button>
              <button
                className="aq-button-2 outline-whitebg-dark-grey"
                onClick={onCancel}
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DateExceptionPromptModal;
